module.exports = System.import('@enersis/gp-components/gp-textarea');